export interface SeasonalProduct {
  name: string;
  displayName: string;
  image: string;
  images: string[];
  description: string;
  badges: string[];
  badge: string;
  available: boolean;
  buttonText: string;
  supplyDetails: {
    availability: string;
    supplyType: string;
    suitableFor: string[];
  };
}

export const currentSeasonalProduct: SeasonalProduct = {
  name: 'Mango',
  displayName: 'Premium Fresh Mango',
  image: '/images/seasonal-mango-thumb.jpg',
  images: [
    '/images/seasonal-mango-1.jpg',
    '/images/seasonal-mango-2.jpg',
    '/images/seasonal-mango-3.jpg',
    '/images/seasonal-mango-4.jpg',
  ],
  description: 'Seasonal fresh mangoes available for bulk supply. Carefully selected quality produce suitable for retailers, restaurants, distributors and business buyers.',
  badges: [
    'Fresh Quality Selected',
    'Bulk Supply Available',
  ],
  badge: 'Seasonal Favourite',
  available: true,
  buttonText: 'Request Mango Supply Quote',
  supplyDetails: {
    availability: 'Seasonal',
    supplyType: 'Bulk Orders',
    suitableFor: ['Retailers', 'Restaurants', 'Distributors', 'Businesses'],
  },
};

export const futureSeasonalProducts: SeasonalProduct[] = [
  {
    name: 'Lychee',
    displayName: 'Fresh Premium Lychee',
    image: '/images/seasonal-lychee-1.jpg',
    images: [
      '/images/seasonal-lychee-1.jpg',
      '/images/seasonal-lychee-2.jpg',
      '/images/seasonal-lychee-3.jpg',
      '/images/seasonal-lychee-4.jpg',
    ],
    description: 'Sweet and juicy seasonal lychee available for bulk supply to businesses and retailers.',
    badges: ['Seasonal Delight', 'Bulk Supply', 'Premium Quality'],
    badge: 'Seasonal Special',
    available: false,
    buttonText: 'Request Lychee Supply Quote',
    supplyDetails: {
      availability: 'Seasonal',
      supplyType: 'Bulk Orders',
      suitableFor: ['Retailers', 'Restaurants', 'Distributors'],
    },
  },
  {
    name: 'Watermelon',
    displayName: 'Fresh Summer Watermelon',
    image: '/images/seasonal-watermelon-1.jpg',
    images: [
      '/images/seasonal-watermelon-1.jpg',
      '/images/seasonal-watermelon-2.jpg',
      '/images/seasonal-watermelon-3.jpg',
      '/images/seasonal-watermelon-4.jpg',
    ],
    description: 'Refreshing summer watermelons available for bulk supply to businesses and retailers.',
    badges: ['Summer Fresh', 'Bulk Supply', 'Quality Assured'],
    badge: 'Summer Pick',
    available: false,
    buttonText: 'Request Watermelon Supply Quote',
    supplyDetails: {
      availability: 'Seasonal',
      supplyType: 'Bulk Orders',
      suitableFor: ['Retailers', 'Restaurants', 'Juice Bars'],
    },
  },
  {
    name: 'Sweet Lime',
    displayName: 'Fresh Sweet Lime (Mosambi)',
    image: '/images/seasonal-sweetlime-1.jpg',
    images: [
      '/images/seasonal-sweetlime-1.jpg',
      '/images/seasonal-sweetlime-2.jpg',
      '/images/seasonal-sweetlime-3.jpg',
      '/images/seasonal-sweetlime-4.jpg',
    ],
    description: 'Juicy sweet lime available for bulk supply to juice bars, restaurants and retailers.',
    badges: ['Citrus Fresh', 'Bulk Supply', 'Premium Grade'],
    badge: 'Citrus Pick',
    available: false,
    buttonText: 'Request Sweet Lime Supply Quote',
    supplyDetails: {
      availability: 'Seasonal',
      supplyType: 'Bulk Orders',
      suitableFor: ['Juice Bars', 'Restaurants', 'Retailers'],
    },
  },
  {
    name: 'Apple',
    displayName: 'Premium Fresh Apple',
    image: '/images/seasonal-apple-1.jpg',
    images: [
      '/images/seasonal-apple-1.jpg',
      '/images/seasonal-apple-2.jpg',
      '/images/seasonal-apple-3.jpg',
      '/images/seasonal-apple-4.jpg',
    ],
    description: 'Crisp premium apples available for bulk supply to businesses and retailers.',
    badges: ['Premium Import', 'Bulk Supply', 'Top Grade'],
    badge: 'Premium Pick',
    available: false,
    buttonText: 'Request Apple Supply Quote',
    supplyDetails: {
      availability: 'Year-Round',
      supplyType: 'Bulk Orders',
      suitableFor: ['Retailers', 'Restaurants', 'Distributors'],
    },
  },
  {
    name: 'Banana',
    displayName: 'Fresh Premium Banana',
    image: '/images/seasonal-banana-1.jpg',
    images: [
      '/images/seasonal-banana-1.jpg',
      '/images/seasonal-banana-2.jpg',
      '/images/seasonal-banana-3.jpg',
      '/images/seasonal-banana-4.jpg',
    ],
    description: 'Fresh bananas available year-round for bulk supply to businesses and retailers.',
    badges: ['Year-Round Supply', 'Bulk Available', 'Quality Fruit'],
    badge: 'Always Fresh',
    available: false,
    buttonText: 'Request Banana Supply Quote',
    supplyDetails: {
      availability: 'Year-Round',
      supplyType: 'Bulk Orders',
      suitableFor: ['Retailers', 'Restaurants', 'Distributors'],
    },
  },
];
